import FixedLeftPanelPageTemplate from 'components/templates/FixedLeftPanelPageTemplate'
import { FloatingGrid } from 'components/atoms/container/ResponsiveContainers'

const LeftPanelTemplate = ({ children, titleGroup, ...otherProps }) => {
  return (
    <FixedLeftPanelPageTemplate
      leftPanelChildren={titleGroup}
      showLogo={false}
      containerProps={{ height: '-webkit-fill-available' }}
      {...otherProps}>
      <FloatingGrid width='100%' container direction='column' wrap='nowrap'>
        {children}
      </FloatingGrid>
    </FixedLeftPanelPageTemplate>
  )
}

export default LeftPanelTemplate
